import { useState } from "react";
import Skeleton from "react-loading-skeleton";

function Description({ details, localLoading = false }) {

  //  Description open by default
  const [activeSection, setActiveSection] = useState("description");

  const handleToggle = (section) => {
    setActiveSection((prev) => (prev === section ? null : section));
  };

  return (
    <>
      {details?.product_info &&
        Object.keys(details.product_info).length > 0 && (
          <>
            {/* DESCRIPTION */}
            <div className="pdp-accordion">
              <div
                className="pdp-accordion-header"
                onClick={() => handleToggle("description")}
              >
                <h3>
                  {localLoading ? (
                    <Skeleton width={180} />
                  ) : (
                    "PRODUCT DESCRIPTION"
                  )}
                </h3>
                {!localLoading && (
                  <span>
                    {activeSection === "description" ? "−" : "+"}
                  </span>
                )}
              </div>

              {!localLoading && activeSection === "description" && (
                <div className="pdp-accordion-content">
                  <p className="pdp-care-text">
                    {details?.product_info?.description}
                  </p>
                </div>
              )}

              {localLoading && (
                <div className="pdp-accordion-content">
                  <Skeleton count={3} />
                </div>
              )}
            </div>

            {/* SPECIFICATIONS */}
            {!["carpet", "runner"].includes(
              details?.sub_category_action_url
            ) && (
                <>
                  <div className="pdp-accordion">
                    <div
                      className="pdp-accordion-header"
                      onClick={() => handleToggle("specs")}
                    >
                      <h3>SPECIFICATIONS</h3>
                      <span>
                        {activeSection === "specs" ? "−" : "+"}
                      </span>
                    </div>

                    {activeSection === "specs" && (
                      <div className="pdp-accordion-content">
                        <table className="pdp-specs-table">
                          <tbody>
                            {Object.entries(details.product_info)
                              .filter(([key]) => key !== "description")
                              .map(([key, value]) => (
                                <tr key={key}>
                                  <td style={{ textTransform: "capitalize" }}>
                                    {key.replace(/_/g, " ")}
                                  </td>
                                  <td>{value}</td>
                                </tr>
                              ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>

                  {/* CARE INSTRUCTIONS */}
                  <div className="pdp-accordion">
                    <div
                      className="pdp-accordion-header"
                      onClick={() => handleToggle("care")}
                    >
                      <h3>CARE INSTRUCTIONS</h3>
                      <span>
                        {activeSection === "care" ? "−" : "+"}
                      </span>
                    </div>

                    {activeSection === "care" && (
                      <div className="pdp-accordion-content">
                        <p className="pdp-care-text">
                          {details?.product_info?.care_instructions}
                        </p>
                      </div>
                    )}
                  </div>
                </>
              )}
          </>
        )}
    </>
  );
}

export default Description;